var _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoName(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 1058.267716535433 377.9527559055118",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l1058.2677 0l0 377.95276l-1058.2677 0l0 -377.95276z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#004e64",
    d: "m0 0l1058.2677 0l0 377.95276l-1058.2677 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadowFilter-p.1)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p.1",
    transform: "matrix(1.0 0.0 0.0 1.0 0.0 2.0)"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shadowFilter-p.1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "blur",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFuncR", {
    type: "linear",
    slope: 0,
    intercept: 0
  }), /*#__PURE__*/React.createElement("feFuncG", {
    type: "linear",
    slope: 0,
    intercept: 0
  }), /*#__PURE__*/React.createElement("feFuncB", {
    type: "linear",
    slope: 0,
    intercept: 0
  }), /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.5,
    intercept: 0
  })))), /*#__PURE__*/React.createElement("g", {
    id: "p.1"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "p.2",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(20.63980279524412 0.0 0.0 20.63980279524412 0.0 0.0)",
    spreadMethod: "pad",
    x1: 8.826209273375296,
    y1: -4.5503992229687,
    x2: -5.7684157172239106,
    y2: 10.044064823728734
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9fffcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#7ae582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#00a5cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a5cf"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p.2)",
    d: "m16.185133 94.87248l0 0c0 -12.596268 10.211294 -22.807564 22.807562 -22.807564l286.35336 0c6.04895 0 11.850128 2.4029312 16.12738 6.6801834c4.277252 4.2772446 6.680176 10.078438 6.680176 16.12738l0 224.87306c0 12.596283 -10.211273 22.807556 -22.807556 22.807556l-286.35336 0c-12.596268 0 -22.807562 -10.211273 -22.807562 -22.807556z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#004e64",
    d: "m22.773321 93.88654l0 0c0 -8.437012 6.8395443 -15.276558 15.276552 -15.276558l288.31305 0c4.0515747 0 7.9372253 1.6094894 10.802155 4.4744034c2.8648987 2.8649063 4.4743958 6.750557 4.4743958 10.802155l0 226.80124c0 8.437012 -6.8395386 15.27655 -15.27655 15.27655l-288.31305 0c-8.437008 0 -15.276552 -6.8395386 -15.276552 -15.27655z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadowFilter-p.3)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p.3",
    transform: "matrix(1.0 0.0 0.0 1.0 0.0 2.0)"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shadowFilter-p.3",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "blur",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFuncR", {
    type: "linear",
    slope: 0,
    intercept: 0
  }), /*#__PURE__*/React.createElement("feFuncG", {
    type: "linear",
    slope: 0,
    intercept: 0
  }), /*#__PURE__*/React.createElement("feFuncB", {
    type: "linear",
    slope: 0,
    intercept: 0
  }), /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.5,
    intercept: 0
  })))), /*#__PURE__*/React.createElement("g", {
    id: "p.3"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m111.58323 286.7753l0 0c0 -4.3019104 3.4873886 -7.7893066 7.7893066 -7.7893066l125.58674 0c2.065857 0 4.0470886 0.8206787 5.5078735 2.281433c1.4607849 1.4607849 2.281433 3.442047 2.281433 5.5078735l0 76.79935c0 4.3019104 -3.4873962 7.7893066 -7.7893066 7.7893066l-125.58674 0c-4.301918 0 -7.7893066 -3.4873962 -7.7893066 -7.7893066z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9fffcb",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m111.58323 286.7753l0 0c0 -4.3019104 3.4873886 -7.7893066 7.7893066 -7.7893066l125.58674 0c2.065857 0 4.0470886 0.8206787 5.5078735 2.281433c1.4607849 1.4607849 2.281433 3.442047 2.281433 5.5078735l0 76.79935c0 4.3019104 -3.4873962 7.7893066 -7.7893066 7.7893066l-125.58674 0c-4.301918 0 -7.7893066 -3.4873962 -7.7893066 -7.7893066z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadowFilter-p.4)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p.4",
    transform: "matrix(1.0 0.0 0.0 1.0 0.0 2.0)"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shadowFilter-p.4",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "blur",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFuncR", {
    type: "linear",
    slope: 0,
    intercept: 0
  }), /*#__PURE__*/React.createElement("feFuncG", {
    type: "linear",
    slope: 0,
    intercept: 0
  }), /*#__PURE__*/React.createElement("feFuncB", {
    type: "linear",
    slope: 0,
    intercept: 0
  }), /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.5,
    intercept: 0
  })))), /*#__PURE__*/React.createElement("g", {
    id: "p.4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#25a18e",
    d: "m5.351343 63.611076l0 0c0 -4.6474 3.7674637 -8.414864 8.414866 -8.414864l33.65846 0l0 0c2.231758 0 4.3721123 0.88656235 5.9502068 2.4646568c1.5780945 1.5780945 2.4646568 3.7184486 2.4646568 5.9502068l0 34.16239c0 4.6474075 -3.7674637 8.414871 -8.414864 8.414871l-33.65846 0l0 0c-4.647403 0 -8.414866 -3.7674637 -8.414866 -8.414871z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadowFilter-p.5)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p.5",
    transform: "matrix(1.0 0.0 0.0 1.0 0.0 2.0)"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shadowFilter-p.5",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "blur",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFuncR", {
    type: "linear",
    slope: 0,
    intercept: 0
  }), /*#__PURE__*/React.createElement("feFuncG", {
    type: "linear",
    slope: 0,
    intercept: 0
  }), /*#__PURE__*/React.createElement("feFuncB", {
    type: "linear",
    slope: 0,
    intercept: 0
  }), /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.5,
    intercept: 0
  })))), /*#__PURE__*/React.createElement("g", {
    id: "p.5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9fffcb",
    d: "m1.0259771 19.933912l0 0c0 -2.6643562 2.1598873 -4.8242445 4.8242435 -4.8242445l19.296394 0l0 0c1.2794685 0 2.5065346 0.5082674 3.411255 1.4129877c0.9047203 0.9047222 1.4129887 2.1317863 1.4129887 3.4112568l0 20.587732c0 2.6643562 -2.1598873 4.8242455 -4.8242435 4.8242455l-19.296394 0c-2.6643562 0 -4.8242435 -2.1598892 -4.8242435 -4.8242455z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadowFilter-p.6)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p.6",
    transform: "matrix(1.0 0.0 0.0 1.0 0.0 2.0)"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shadowFilter-p.6",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "blur",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFuncR", {
    type: "linear",
    slope: 0,
    intercept: 0
  }), /*#__PURE__*/React.createElement("feFuncG", {
    type: "linear",
    slope: 0,
    intercept: 0
  }), /*#__PURE__*/React.createElement("feFuncB", {
    type: "linear",
    slope: 0,
    intercept: 0
  }), /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.5,
    intercept: 0
  })))), /*#__PURE__*/React.createElement("g", {
    id: "p.6"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7ae582",
    d: "m62.842186 27.130774l0 0c0 -3.7921429 3.0741425 -6.8662796 6.8662796 -6.8662796l27.464294 0l0 0c1.8210526 0 3.5675125 0.72340965 4.855194 2.0110855c1.287674 1.2876778 2.0110855 3.0341434 2.0110855 4.855194l0 28.881613c0 3.792141 -3.0741425 6.8662796 -6.8662796 6.8662796l-27.464294 0c-3.7921371 0 -6.8662796 -3.0741386 -6.8662796 -6.8662796z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadowFilter-p.7)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p.7",
    transform: "matrix(1.0 0.0 0.0 1.0 0.0 2.0)"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shadowFilter-p.7",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "blur",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFuncR", {
    type: "linear",
    slope: 0,
    intercept: 0
  }), /*#__PURE__*/React.createElement("feFuncG", {
    type: "linear",
    slope: 0,
    intercept: 0
  }), /*#__PURE__*/React.createElement("feFuncB", {
    type: "linear",
    slope: 0,
    intercept: 0
  }), /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.5,
    intercept: 0
  })))), /*#__PURE__*/React.createElement("g", {
    id: "p.7"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00a5cf",
    d: "m69.350334 100.16197l0 0c0 -5.8766556 4.763977 -10.640633 10.640633 -10.640633l42.561256 0l0 0c2.822075 0 5.528557 1.1210632 7.5240707 3.1165695c1.9954987 1.9955063 3.116562 4.701996 3.116562 7.524063l0 43.03369c0 5.876663 -4.763977 10.64064 -10.640633 10.64064l-42.561256 0l0 0c-5.8766556 0 -10.640633 -4.763977 -10.640633 -10.64064z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadowFilter-p.8)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p.8",
    transform: "matrix(1.0 0.0 0.0 1.0 0.0 2.0)"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shadowFilter-p.8",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "blur",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFuncR", {
    type: "linear",
    slope: 0,
    intercept: 0
  }), /*#__PURE__*/React.createElement("feFuncG", {
    type: "linear",
    slope: 0,
    intercept: 0
  }), /*#__PURE__*/React.createElement("feFuncB", {
    type: "linear",
    slope: 0,
    intercept: 0
  }), /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.5,
    intercept: 0
  })))), /*#__PURE__*/React.createElement("g", {
    id: "p.8"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff825c",
    d: "m36.97378 4.175527l0 0c0 -1.7366152 1.4078064 -3.1444201 3.1444206 -3.1444201l12.577301 0l0 0c0.83395386 0 1.6337471 0.3312862 2.223442 0.92097926c0.58969116 0.5896932 0.92097855 1.3894886 0.92097855 2.2234406l0 13.112734c0 1.7366161 -1.4078026 3.1444206 -3.1444206 3.1444206l-12.577301 0c-1.7366142 0 -3.1444206 -1.4078045 -3.1444206 -3.1444206z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadowFilter-p.9)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p.9",
    transform: "matrix(1.0 0.0 0.0 1.0 0.0 4.0)"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shadowFilter-p.9",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "blur",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFuncR", {
    type: "linear",
    slope: 0,
    intercept: 0
  }), /*#__PURE__*/React.createElement("feFuncG", {
    type: "linear",
    slope: 0,
    intercept: 0
  }), /*#__PURE__*/React.createElement("feFuncB", {
    type: "linear",
    slope: 0,
    intercept: 0
  }), /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.5,
    intercept: 0
  })))), /*#__PURE__*/React.createElement("g", {
    id: "p.9"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m59.964367 163.34383l1026.3307 0l0 215.55904l-1026.3307 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7ae582",
    d: "m156.8202 181.47414l-46.71875 143.34373l0 -0.203125q-1.28125 3.1875 -3.53125 5.21875q-2.234375 2.03125 -5.421875 2.03125q-1.71875 0 -3.3125 -0.328125q-1.59375 -0.3125 -3.3125 -0.734375l0.21875 0q-12.15625 -3.84375 -8.953125 -13.65625l48.625 -147.84373q1.078125 -3.40625 3.734375 -5.75q2.671875 -2.359375 6.296875 -2.78125q3.625 -0.640625 7.03125 -0.953125q3.421875 -0.328125 5.34375 -0.328125q1.921875 0 5.328125 0.328125q3.421875 0.3125 7.046875 0.75q2.984375 0.421875 5.859375 3.203125q2.890625 2.765625 4.375 5.53125q11.953125 36.703125 24.21875 73.9375q12.265625 37.218735 24.203125 73.906235q3.0 9.8125 -8.953125 13.65625q-1.703125 0.421875 -3.09375 0.734375q-1.390625 0.328125 -3.09375 0.328125q-2.984375 0 -5.4375 -2.03125q-2.453125 -2.03125 -3.515625 -5.21875l0 0.203125l-46.9375 -143.34373zm16.0 97.26561q0 6.828125 -4.796875 11.640625q-4.796875 4.796875 -11.625 4.796875q-6.828125 0 -11.53125 -4.796875q-4.6875 -4.8125 -4.6875 -11.640625q0 -6.828125 4.6875 -11.625q4.703125 -4.796875 11.53125 -4.796875q6.828125 0 11.625 4.796875q4.796875 4.796875 4.796875 11.625zm95.35872 42.25q0 10.234375 -11.734375 10.234375q-12.15625 0 -12.15625 -10.234375l0 -88.32811q0 -17.484375 10.453125 -24.3125q10.453125 -6.828125 24.109375 -6.828125l24.3125 0q7.890625 0 7.890625 10.03125q0.421875 10.015625 -7.890625 10.015625l-22.609375 0q-7.6875 0 -10.03125 3.0q-2.34375 2.984375 -2.34375 8.3125l0 88.10936z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9fffcb",
    d: "m357.3552 320.98975q0 10.234375 -12.8125 10.234375q-12.578125 0 -12.578125 -10.234375l0 -151.24998q0 -10.25 12.578125 -10.25q12.8125 0 12.8125 10.25l0 151.24998zm91.09061 0.421875q0 10.234375 -12.8125 10.234375q-12.578125 0 -12.578125 -10.234375l0 -139.31248l-37.328125 0q-7.6875 0 -8.109375 -10.875q0 -10.65625 8.109375 -10.65625l100.046875 0q8.109375 0 7.671875 10.65625q0 10.875 -7.671875 10.875l-37.328125 0l0 139.31248z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7ae582",
    d: "m525.8716 330.16162q-7.890625 0 -10.671875 -4.046875q-2.765625 -4.0625 -2.765625 -8.96875l0 -147.40623q0 -10.25 12.375 -10.25q12.796875 0 12.796875 10.25l0 138.87498l71.25 0q7.6875 0 7.6875 10.453125q0.421875 11.09375 -7.6875 11.09375l-82.984375 0zm176.6366 -128.64061q5.546875 0 11.40625 2.34375q5.875 2.34375 11.421875 5.96875l-0.203125 0q5.546875 4.0625 8.53125 10.578125q2.984375 6.5 2.984375 15.03125l0 60.57811q0 17.5 -11.515625 25.8125q-11.3125 8.109375 -22.625 8.109375l-34.125 0q-5.546875 0 -11.3125 -1.921875q-5.75 -1.921875 -11.296875 -6.1875q-11.53125 -8.109375 -11.53125 -25.8125l0 -60.57811q0 -8.53125 2.984375 -15.03125q3.0 -6.515625 8.546875 -10.578125l-0.21875 0q5.328125 -3.625 11.296875 -5.96875q5.984375 -2.34375 11.53125 -2.34375l34.125 0zm-3.828125 108.374985q7.890625 0 11.1875 -4.484375q3.3125 -4.484375 3.3125 -9.59375l0 -60.17186q0 -5.328125 -3.3125 -9.703125q-3.296875 -4.375 -11.1875 -4.375l-26.453125 0q-7.90625 0 -11.21875 4.375q-3.296875 4.375 -3.296875 9.703125l0 60.17186q0 5.109375 3.296875 9.59375q3.3125 4.484375 11.21875 4.484375l26.453125 0zm99.183044 5.109375q-5.53125 0 -11.40625 -1.90625q-5.859375 -1.921875 -11.40625 -5.5625q-11.53125 -7.453125 -11.53125 -25.171875l0 -48.20311q0 -8.96875 3.09375 -15.359375q3.09375 -6.40625 8.4375 -10.03125q5.546875 -3.40625 11.296875 -5.328125q5.765625 -1.921875 11.3125 -1.921875l35.84375 0q5.328125 0 11.078125 2.34375q5.765625 2.34375 10.671875 5.96875q4.90625 4.0625 7.890625 10.671875q2.984375 6.609375 2.984375 14.9375l0 90.45311q0 8.953125 -2.875 15.25q-2.875 6.296875 -8.0 10.5625q-4.90625 4.046875 -10.5625 6.28125q-5.640625 2.25 -11.1875 2.25l-35.84375 0q-11.3125 0 -22.828125 -6.625q-5.96875 -3.40625 -8.640625 -8.75q-2.671875 -5.328125 -2.671875 -12.359375l0 -2.5625q0 -4.265625 2.765625 -6.828125q2.78125 -2.5625 8.765625 -2.5625q11.9375 1.28125 11.9375 9.390625l0 2.34375q0 2.34375 3.296875 5.109375q3.3125 2.78125 11.21875 2.78125l26.65625 0q7.890625 0 11.203125 -4.484375q3.3125 -4.46875 3.3125 -10.015625l0 -90.031235q0 -5.328125 -3.3125 -9.703125q-3.3125 -4.375 -11.203125 -4.375l-26.65625 0q-7.90625 0 -11.21875 4.375q-3.296875 4.375 -3.296875 9.703125l0 45.01561q0 5.328125 3.296875 9.921875q3.3125 4.59375 11.21875 4.59375l22.1875 0q7.671875 0 7.671875 9.8125q0 4.46875 -1.8125 7.25q-1.8125 2.765625 -5.859375 2.765625l-25.828125 0zm120.96246 5.984375q0 10.234375 -11.734375 10.234375q-11.9375 0 -11.9375 -10.234375l0 -110.07811q0 -10.25 11.9375 -10.25q11.734375 0 11.734375 10.25l0 110.07811zm4.484375 -147.20311q0 6.828125 -4.703125 11.53125q-4.6875 4.6875 -11.515625 4.6875q-6.828125 0 -11.625 -4.6875q-4.796875 -4.703125 -4.796875 -11.53125q0 -7.046875 4.796875 -11.734375q4.796875 -4.6875 11.625 -4.6875q6.828125 0 11.515625 4.6875q4.703125 4.6875 4.703125 11.734375zm127.77429 122.23436q0 17.5 -11.515625 25.8125q-11.296875 8.109375 -22.609375 8.109375l-35.84375 0q-11.296875 0 -21.96875 -8.109375q-5.125 -4.265625 -7.90625 -10.765625q-2.765625 -6.515625 -2.765625 -15.046875l0 -60.79686q0 -17.28125 10.671875 -25.59375q5.328125 -3.84375 10.984375 -6.078125q5.65625 -2.25 10.984375 -2.25l35.84375 0q5.125 0 11.3125 2.03125q6.1875 2.03125 11.515625 5.4375q5.125 3.625 8.203125 10.03125q3.09375 6.390625 3.09375 15.140625l0 10.671875q0 10.234375 -11.71875 10.234375q-11.734375 0 -11.734375 -10.234375l0 -9.171875q0 -5.34375 -3.3125 -9.703125q-3.3125 -4.375 -11.203125 -4.375l-26.65625 0q-7.90625 0 -11.21875 4.375q-3.296875 4.359375 -3.296875 9.703125l0 60.374985q0 5.109375 3.296875 9.59375q3.3125 4.484375 11.21875 4.484375l26.65625 0q7.890625 0 11.203125 -4.484375q3.3125 -4.484375 3.3125 -9.59375l0 -9.828125q0 -10.015625 11.734375 -10.015625q11.71875 0 11.71875 10.015625l0 10.03125z",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoName);
export default __webpack_public_path__ + "static/media/logo-name.5002f7931260f4d0222b448da3c6f4bb.svg";
export { ForwardRef as ReactComponent };